import { simpleSet } from '@r/reducers/utils';

const setCalculationModePullsOptions = simpleSet as
  redux.reducers.calculationMode.settings.materials.pulls.options;

export const options = setCalculationModePullsOptions(
  'SET_CALCULATION_MODE_PULLS_OPTIONS',
  []
);
